import { ADMIN_LANGUAGE_NAMES, ADMIN_LANGUAGES } from '@sirius/contracts/admin'
import { useTranslation } from 'react-i18next'
import {
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
} from '~/components/ui/dropdownMenu'
import { isAdminLanguage } from '~/i18n/adminLanguage'
import { useMyLanguage } from '~/i18n/useMyLanguage'
import { fromOwn, toOwn, USE_DEFAULT } from '~/lib/inheritable'

/**
 * "My language" in the user menu: Use default (with the language it gives
 * today) and each panel language by its own name. Rendered once the session
 * has loaded; a choice is saved at once and the panel switches to it.
 */
export function MyLanguageMenu() {
  const { t } = useTranslation()
  const { language, inheritedLanguage, setLanguage, saving } = useMyLanguage()

  if (inheritedLanguage === undefined) {
    return null
  }

  return (
    <>
      <DropdownMenuLabel>
        {t('shell.userMenu.language.title')}
      </DropdownMenuLabel>
      <DropdownMenuRadioGroup
        value={fromOwn(language)}
        onValueChange={(choice) => {
          setLanguage(toOwn(choice, isAdminLanguage))
        }}
      >
        <DropdownMenuRadioItem
          value={USE_DEFAULT}
          disabled={saving}
        >
          {t('shell.userMenu.language.useDefaultWith', {
            language: ADMIN_LANGUAGE_NAMES[inheritedLanguage],
          })}
        </DropdownMenuRadioItem>
        {ADMIN_LANGUAGES.map((code) => (
          <DropdownMenuRadioItem
            key={code}
            value={code}
            disabled={saving}
          >
            {ADMIN_LANGUAGE_NAMES[code]}
          </DropdownMenuRadioItem>
        ))}
      </DropdownMenuRadioGroup>
      <DropdownMenuSeparator />
    </>
  )
}
